// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"343":"740bcf33","875":"b37fad64","958":"311cda14"}[chunkId] + ".chunk.js";
};